<template>
  <div class="lesson-list-create-element-option container-fluid margin-Bottom-1Point5Perc margin-Top-2Point5Perc"> 
    <div class="admin-Panel-Padding">
      <div class="row">
        <div class="col-sm-2 col-md-3 col-lg-3">
        </div>
        <div class="col-xs-8 col-sm-4 col-md-3 col-lg-3">
          <select class="form-control" v-model="selectedElementType">
            <option value=-1 disabled>Select Step to be added</option>
            <option value="13" v-if="getAssessmentOptionVisibility">Assessment</option>
            <option value="7" v-if="getBonusOptionVisibility">Bonus Content</option>
            <option value="1" v-if="getChallengeOptionVisibility">Challenge</option>
            <!--<option value="5" disabled>Diary Entry</option>-->
            <option value="9" v-if="getDescVideoOptionVisibility">Descriptive Video</option>
            <option value="8" v-if="getDocumentOptionVisibility">Document</option>
            <option value="11" v-if="getLearnGameOptionVisibility">Learning Game</option>
            <option value="3" v-if="getMCQOptionVisibility">MCQ Quiz</option>
            <option value="12" v-if="getMissionOptionVisibility">Mission</option>
            <option value="10" v-if="getRatingOptionVisibility">Rating</option>
            <option value="2" v-if="getReflectionOptionVisibility">Reflection</option>
            <option value="6" v-if="getNoteOptionVisibility">Text Page (Note)</option>
            <option value="0" v-if="getVideoOptionVisibility">Video</option>
          </select>
        </div>
        <div class="col-xs-8 col-sm-4 col-md-3 col-lg-3">
          <button class="btn btn-primary btn-block center-align-div create-element-button-BG black-font-color" v-on:click="updateHideCreateElementOverlayFlag($event,false)">{{courseElementButtonTitle}}</button>
        </div>
        <div class="col-md-3 col-lg-3">
        </div>
      </div>
    </div> 
    <create-bonus-module-overlay v-if="showBonusModuleCreationOverlay" @closeBonusModuleOverlay="closeBonusOverlay" @isBonusModuleCreated="updateNotCreatedBonusModule" v-bind:selectedLessonObj="lessonObj"></create-bonus-module-overlay>
    <create-video-element v-if="isVideo" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-video-element>
    <create-assessment-element v-if="isAssessment" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-assessment-element>
    <create-challenge-element v-if="isChallenge" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-challenge-element>
    <create-reflection-discussion-element v-if="isRD" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-reflection-discussion-element>
    <create-document-element v-if="isDocument" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-document-element>
    <create-note-element v-if="isNote" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-note-element>
    <create-mcq-element v-if="isMCQ" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-mcq-element>
    <create-bonus-content-element v-if="isBonusContent" @showAssociateMsg="updateShowAssociateMsgFlag" @openOverlay="openCreateStepOverlay" v-bind:showAssociateMsg="showMsg" v-bind:lessonObj="lessonObj" v-bind:isBonusModuleCreated="getIsCreatedBonusModuleFlag" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList" @openBonusModuleCreationOverlay="openBonusModuleCreationOverlay"></create-bonus-content-element>
    <create-video-text-element v-if="isVideoText" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-video-text-element>
    <create-post-element v-if="isPostElement" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-post-element>
    <create-adaptive-game v-if="isAdaptiveGame" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-adaptive-game>
    <create-mission-game v-if="isMissionGame" @openOverlay="openCreateStepOverlay" v-bind:lessonObj="lessonObj" @showSpinner="updateShowSpinnerFlag" @refreshElementList="refreshElementList"></create-mission-game>

    <!-- Alert Overlay -->
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { moduleService } from '@/server-util/module-service'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import CreateVideoElement from '@/components/CreateVideoElement'
import CreateAssessmentElement from '@/components/CreateAssessmentElement'
import CreateChallengeElement from '@/components/CreateChallengeElement'
import CreateReflectionDiscussionElement from '@/components/CreateReflectionDiscussionElement'
import CreateDocumentElement from '@/components/CreateDocumentElement'
import CreateNoteElement from '@/components/CreateNoteElement'
import CreateMCQElement from '@/components/CreateMCQElement'
import CreateBonusContentElement from '@/components/CreateBonusContentElement'
import CreateBonusModuleOverlay from '@/components/CreateBonusModuleOverlay'
import CreateVideoTextElement from '@/components/CreateVideoTextElement'
import CreatePostElement from '@/components/CreatePostElement'
import { elementService } from '@/server-util/element-service'
import CreateAdaptiveGame from '@/components/adaptive_game/AdaptiveGameOverlay'
import CreateMissionGame from '@/components/mission_game/MissionGameOverlay'
export default {
  props: ['lessonObj'],
  name: 'lesson-list-create-element-option',
  data: function () {
    return {
      constants: constants,
      courseElementButtonTitle: '+ Create Step',
      hideCreateElementOverlay: true,
      selectedElementType: -1,
      isBonusContent: false,
      isChallenge: false,
      isDiaryEntry: false,
      isDocument: false,
      isMCQ: false,
      isRD: false,
      isNote: false,
      isVideo: false,
      isAssessment: false,
      isVideoText: false,
      isPostElement: false,
      isAdaptiveGame: false,
      isMissionGame: false,
      isMission: false,
      errorMsg: '',
      showAlertDialog: false,
      showSpinner: false,
      showBonusModuleCreationOverlay: false,
      isBonusModuleCreated: true,
      showMsg: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'create-video-element': CreateVideoElement,
    'create-assessment-element': CreateAssessmentElement,
    'create-challenge-element': CreateChallengeElement,
    'create-reflection-discussion-element': CreateReflectionDiscussionElement,
    'create-document-element': CreateDocumentElement,
    'create-note-element': CreateNoteElement,
    'create-mcq-element': CreateMCQElement,
    'create-bonus-content-element': CreateBonusContentElement,
    'create-bonus-module-overlay': CreateBonusModuleOverlay,
    'create-video-text-element': CreateVideoTextElement,
    'create-post-element': CreatePostElement,
    'create-adaptive-game': CreateAdaptiveGame,
    'create-mission-game': CreateMissionGame,
    'loader': Loader
  },
  methods: {
    /* performMissionAction (value) {
      var closeMissionOverlay = value.closeOverlay
      var lessonObj = value.lessonObj
      var missionGameResp = value.missionGameResp
      var overallOpeningQuestionList = value.overallOpeningQuestionList
      this.isMissionGame = !closeMissionOverlay
    }, */
    updateShowAssociateMsgFlag (value) {
      // AK: After showing msg to user on create bonus element set flag again as flase
      this.showMsg = false
    },
    updateNotCreatedBonusModule (value) {
      // AK: If user created/ already present bonus module then update flag as true else false
      this.isBonusModuleCreated = value
      // AK: If bonus module created then only set showMsg as true
      if (value === true) {
        this.showMsg = true
      }
    },
    openBonusModuleCreationOverlay (value) {
      // AK: Used to show bonus module creation overlay
      this.showBonusModuleCreationOverlay = value
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeBonusOverlay (value) {
      // AK: Used to hide bonus module creation overlay if user pressed X explicitly
      this.showBonusModuleCreationOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value

      // AK: Again open add bonus content overlay
      this.isBonusContent = true
      // AK: Disabled Background Scrolling
      this.$store.state.isOverlayVisible = true
    },
    updateShowSpinnerFlag (value) {
      // AK: As Soon as any create element request send to server show spinner and Hide spinner after recieving updated element list
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    openCreateStepOverlay (value) {
      this.isBonusContent = value
      this.isChallenge = value
      this.isDiaryEntry = value
      this.isDocument = value
      this.isMCQ = value
      this.isRD = value
      this.isNote = value
      this.isVideo = value
      this.isAdaptiveGame = value
      this.isVideoText = value
      this.isPostElement = value
      this.isAdaptiveGame = value
      this.isMissionGame = value
      this.isAssessment = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateHideCreateElementOverlayFlag: function (event, flagToUpdate) {
      // AK: no need to check while closing create element overlay
      if (flagToUpdate === false) {
        if (this.selectedElementType === -1) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a step.'
        } else {
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = !flagToUpdate
          this.hideCreateElementOverlay = flagToUpdate
          switch (this.selectedElementType) {
            case '0':
              this.isVideo = true
              break
            case '1':
              this.isChallenge = true
              break
            case '2':
              this.isRD = true
              break
            case '3':
              this.isMCQ = true
              break
            case '5':
              this.isDiaryEntry = true
              break
            case '6':
              this.isNote = true
              break
            case '7':
              this.isBonusModuleCreated = true
              this.isBonusContent = true
              break
            case '8':
              this.isDocument = true
              break
            case '9':
              this.isVideoText = true
              break
            case '10':
              this.isPostElement = true
              break
            case '11':
              this.isAdaptiveGame = true
              break
            case '12':
              this.isMissionGame = true
              break
            case '13':
              this.isAssessment = true
          }
        }
      } else {
        // AK: Enable background scrolling
        this.$store.state.isOverlayVisible = !flagToUpdate
        this.hideCreateElementOverlay = flagToUpdate
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    refreshElementList (value) {
      if (value) {
        // AK: On success Response of Create element, Get element list again
        this.getElementList()
      }
    },
    getElementList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.lessonObj.ModuleId !== undefined ||
        this.lessonObj.ModuleId !== null ||
        this.lessonObj.length > 0
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.lessonObj.ModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Modules (For duration update)
              _this.refreshModules()
              // AK: Hide Spinner after recieving updated Element list
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Hide Create Element Overlay after getting updated ElementList
              this.openCreateStepOverlay(false)
              // aK: Enable background scrolling
              this.$store.state.isOverlayVisible = false
              // AK: In order to show newly refreshed Element List (LessonList file)
              _this.$emit('updatedElementList', responseObj.data)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ElementId is NULL hence declined LOADING ELEMENT LIST OPERATION [AFTER ADDING NEW ELEMENT]'
        )
      }
    },
    refreshModules: function () {
      var storeObj = this.$store
      if (storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined || storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== null) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Update all Modules in a background
              storeObj.state.selectedMasterClassModuleList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined GETTING CURRENT MODULE DATA [AFTER UPDATE/DELETE]'
        )
      }
    }
  },
  computed: {
    getAssessmentOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getBonusOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getChallengeOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getDescVideoOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getVideoOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getLearnGameOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getMissionOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getRatingOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getReflectionOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return false
        } else {
          return true
        }
      }
    },
    getDocumentOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          if (this.lessonObj.ModuleType === constants.ModuleType.Normal) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    getNoteOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          if (this.lessonObj.ModuleType === constants.ModuleType.Normal) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    getMCQOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          if (this.lessonObj.ModuleType === constants.ModuleType.Personalization || this.lessonObj.ModuleType === constants.ModuleType.Assessment) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    getIsCreatedBonusModuleFlag: {
      get: function () {
        return this.isBonusModuleCreated
      }
    },
    currentSelectedCourseTypeValue: {
      get: function () {
        return parseInt(this.$store.state.selectedCourseObjFromFilter.Type)
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
  padding-top: 6%;
  padding-bottom: 6%;
}

.overlay-content {
  position: relative;
  /*top: 25%;*/
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.width {
  width: 95%;
}

.vertical-align {
  display: flex;
  align-items: center;
}
.create-element-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-element-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.margin-Bottom-1Point5Perc {
  padding-bottom: 1.5%;
}
.margin-Top-2Point5Perc {
  padding-top: 2.5%;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.center-align-div {
  margin: 0 auto;
}
.cursor-pointer {
  cursor: pointer;
}
.font-wight-bold {
  font-weight: bold;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.create-element-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.overlay-select-menu-width-93Perc {
  width: 93% !important;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.border-color-green {
  border: 1px solid green;
}
.border-color-black {
  border: 1px solid black;
}
.border-red {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/LessonListCreateElementOption.vue